import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('app', ['successToast', 'failToast', 'infoToast']),
  },
};
